export enum EVideoPlayerType {
  Unknown = 0,
  File = 1,
  Url = 2,
  Youtube = 3,
  Vimeo = 4,
}
